import React from "react";

/**
 * Common Success Messages
 */
const SUCCESS_MESSAGES = {};

/**
 * Auth (Login | Signup) Messages
 */
const AUTH_MSG = {
  unauthorized: "401: Unauthorized",
  no_res: "0: No response",
  bad_request: "400: Bad request",
  forbidden: "403: Requested resource is forbidden",
  not_found: "404: Not found",
  not_allowed: "405: Method not allowed",
  access_denied: "412: Precondition failed, access denied",
  unprocessable: "422: Unprocessable entity",
  bad_gateway: "502: Bad gateway",
  service_unavailable: "503: Service unavailable",
  timeout: "504: Gateway timeout",
};

const ERROR_MESSAGES = {
  internal_error: "Internal server error"
}

export { SUCCESS_MESSAGES, AUTH_MSG, ERROR_MESSAGES };
